// extracted by css-extract-rspack-plugin
export default {"ActionMenu_Overlay":"slice-by-menu-module__ActionMenu_Overlay__GAge7"};